

<script>
import {uploadLogs} from '@/api/user'
export default {
    data(){
        return {
            countDownNum:15,
            dialogVisible: false
        }
    },
    destroyed(){
        if(typeof(this.checkScannerLocationTimer) !== "undefined") {
            clearTimeout(this.checkScannerLocationTimer);
        }
    },
    methods: {
        handleClose(){
            this.errorDialogVisible = false
        },
        // ---------硬件-----------
        scan() {
            this.$emit('ControlLight', 'printer_light', '0');
            this.$emit('PlaySound','scaning');
            return new Promise(async (resolve,reject) => {
                let param = {};
                let url1 = ".\\scanPic\\" + this.getdate() +"_front_image" + ".jpg";
                let url2 = ".\\scanPic\\" + this.getdate() +"_back_image" + ".jpg";
                param.front_image = url1;
                param.back_image = url2;
                let result = await this.ist.scan(param);
                // console.log('scan:' + JSON.stringify(result));
                if (result.result == 0) {
                    try {
                        // 检测排纸单元状态
                        await this.getStatus()
                        resolve({status: 0})
                    } catch (error) {
                        // 排纸单元卡纸
                        reject({status: 5})
                    }
                    
                } else if (result.result == -29) { //扫描仪入口处无纸   
                    reject({status: 1})
                } else if (result.result == -20 || result.result == -5) { //扫描仪卡纸
                    reject({status: 2})
                }else if (result.result == -24){ // 扫描仪开盖
                    reject({ status: 3})
                } else { //其他未知错误
                    this.errorMessage = '扫描仪扫描发生未知错误,请联系工作人员处理,错误码:' + JSON.stringify(result)
                    this.errorDialogVisible = true
                    console.error("发生错误:" + result.message);
                    uploadLogs({
                        content: JSON.stringify(result),
                        errorCode:result.result,
                        module: '扫描仪扫描'
                    }).catch(e => {})
                    reject({status: 4})
                }
            })    
        },

        //  获取排纸单元是否卡纸
        getStatus(){
            return new Promise(async (reslove,reject) => {
                let result = await this.ist.call("get_sensor_status")
                console.log('get_sensor_status',result)
                if(result.result === 0){
                    if(result.sensor.sensor13 === 0){
                        // 排纸单元卡纸
                        reject({status: 5})
                    }else {
                        reslove({status: 0})
                    }
                }
            })
            
        },
        // 获取时间
        getdate() {
            let time = new Date();
            let year = time.getFullYear();
            let month = time.getMonth() + 1;
            let day = time.getDate();
            let dateStr = year + "" + (month < 10 ? "0" + month : month) + "" + (day < 10 ? "0" + day : day);
            return dateStr;
        },
        // 读取文件为base64
        async readFileAsBase64(url) {
            let param ={};
            param.file = url;
			param.binary = true;
			param.base64 = true;
			let result = await this.sys.read(param);
            if(result.result == 0) {
				let data = result.data;
				return data;
			} else {
				console.error("读取扫描图片base64发生错误:" + result.message);
                this.errorMessage = '读取扫描图片base64发生未知错误,请联系工作人员处理,错误码' + JSON.stringify(result)
                this.errorDialogVisible = true
                uploadLogs({
                    content: JSON.stringify(result),
                    errorCode:result.result,
                    module: '读取扫描图片base64'
                }).catch(e => {})
			}
        },
         // 弹出扫描仪
        async unlockScanner() {
            return new Promise(async(reslove,reject) => {
                let result = await this.ist.call("unlock");
                console.log("unlock:" + JSON.stringify(result));
                if(result.result == 0){
                    console.log("弹出扫描仪成功");
                    this.waitScannerLocationDialogVisible = true
                    this.startCheckScannerLocationTimer();
                    reslove()
                } else {
                    console.error("弹出扫描仪发生错误:" + result.message);
                    this.errorMessage = '弹出扫描仪发生未知错误,请联系工作人员处理,错误码' + JSON.stringify(result)
                    this.errorDialogVisible = true
                    uploadLogs({
                        content: JSON.stringify(result),
                        errorCode:result.result,
                        module: '弹出扫描仪'
                    }).catch(e => {})
                    reject()
                }
            })
        },
         // 检查扫描仪是否处于可应用状态
        async startCheckScannerLocationTimer() {
            let result = await this.ist.call("get_sensor_status");
            console.log("---get_sensor_status:---" + JSON.stringify(result));
            if(result.result == 0) {
                let sensor = result.sensor;
                let scannerLocationSensor = sensor.sensor17;
                if(scannerLocationSensor == 0) { //扫描仪已归位
                    console.info('==========第一次复位')
                    await this.sleep(500)
                    await this.againStartCheckScannerLocationTimer().then(async res => {
                        await this.resetDevice();
                        this.waitScannerLocationDialogVisible = false
                        //检查纸盘是否有纸
                        // 从父级的mixin中引入的方法
                        await this.checkPaperDishSensor().then(res => {
                            if(res.status === 0){
                                // 有纸
                                // this.ejectFileDialogVisible = true
                                this.handleContinueScan()
                            }else {
                                // 托盘无纸处理
                                this.dishHaveNoPaper()
                            }
                        })
                    })
                } else { //扫描仪未归位
                    setTimeout(() => {
                        this.startCheckScannerLocationTimer();
                    }, 500);
                }
            } else {
                console.error("获取收票模块传感器发生错误:" + result.message);
                this.errorMessage = '获取收票模块传感器未知错误,请联系工作人员处理,错误码' + JSON.stringify(result)
                this.errorDialogVisible = true
                this.waitScannerLocationDialogVisible = false
                uploadLogs({
                    content: JSON.stringify(result),
                    errorCode:result.result,
                    module: '获取收票模块传感器'
                }).catch(e => {})
            }
        },
        // 再次检查扫描仪是否处于可应用状态
        againStartCheckScannerLocationTimer(){
            return new Promise(async (reslove,reject) => {
                let result = await this.ist.call("get_sensor_status");
                console.log("get_sensor_status:" + JSON.stringify(result));
                if(result.result == 0) {
                    let sensor = result.sensor;
                    let scannerLocationSensor = sensor.sensor17;
                    if(scannerLocationSensor == 0) {
                        console.info('==========第二次复位')
                        reslove()
                    }else { //扫描仪未归位
                        setTimeout(() => {
                            this.startCheckScannerLocationTimer();
                        }, 500);
                    }
                }else {
                    console.error("获取收票模块传感器发生错误:" + result.message);
                    this.errorMessage = '获取收票模块传感器未知错误,请联系工作人员处理,错误码' + JSON.stringify(result)
                    this.errorDialogVisible = true
                    this.waitScannerLocationDialogVisible = false
                    uploadLogs({
                        content: JSON.stringify(result),
                        errorCode:result.result,
                        module: '获取收票模块传感器'
                    }).catch(e => {})
                }
            })
            
        },
         // 重置收票模块
        async resetDevice() {
            let result = await this.ist.resetDevice();
            console.log("resetDevice:" + JSON.stringify(result));
            if(result.result == 0) {
                console.log("重置收票模块成功");
            } else {
                console.log("重置收票模块发生错误:" +  + result.message);
                console.error("重置收票模块发生错误:" + result.message);
                this.errorMessage = '重置收票模块发生错误,请联系工作人员处理,错误码' + JSON.stringify(result)
                this.errorDialogVisible = true
                uploadLogs({
                    content: JSON.stringify(result),
                    errorCode:result.result,
                    module: '重置收票模块'
                }).catch(e => {})
            }
        },
        // 存入纸仓
        async retain() {
            return new Promise(async (reslove,reject) => {
                let result = await this.ist.call("retain");
                console.log('retain:' + JSON.stringify(result));
                if(result.result == 0){
                    console.log("存入文件成功");
                    //设备需要时间，可酌情修改时间，暂定2秒
                    setTimeout(() => {
                        this.$emit('PlaySound','processEnd');
                        reslove()
                    }, 3000)
                } else if (result.result == -11) { //纸仓已满
                    // 设备存储仓已满,无法继续投递,请退出登录
                    reject({status: -11})
                } else {
                    this.errorMessage = '设备存入文件发生错误,请联系工作人员处理,错误码' + JSON.stringify(result)
                    this.errorDialogVisible = true
                    uploadLogs({
                        content: JSON.stringify(result),
                        errorCode:result.result,
                        module: '设备存入文件'
                    }).catch(e => {})
                }
            })
        },
        sleep (ms){
            return new Promise(reslove => setTimeout(reslove,ms))
        }
    }
}
</script>



